import styled from "styled-components";

export const DefaultContentsPadding = styled.div`
padding: 25px 25px 25px 25px;
height: calc(100% - 85px);

`;